import { render, staticRenderFns } from "./messageEditTabInformation.vue?vue&type=template&id=468d2beb&scoped=true&"
import script from "./messageEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./messageEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./messageEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d2beb",
  null
  
)

export default component.exports